import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const CatalogsStyles: moduleStyleType = {
    searchResults: {
        width: '100%',
        borderRadius: '6px',
        backgroundColor: 'background.default',
        '& .MuiGrid-container .MuiGrid-item': {
            padding: 1,
            '&:hover': {
                cursor: 'pointer',
                backgroundColor: 'grey.200',
            },
        },
    },
    autoWidth: {
        '& .MuiGrid-item': {
            width: 'auto',
        },
    },
    hand: {
        cursor: 'pointer',
    },
    empty: {
        '& .MuiTypography-root': {
            color: 'text.secondary',
            fontWeight: 450,
        },
    },
    expandableCatalogListContainer: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
    },
    catalogList: {
        marginRight: 1,
    },
    catalogItem: {
        display: 'inline',
    },
    collapseCount: {
        fontSize: '14px',
        lineHeight: '1.3',
        height: '1em',
    },
}
